export const validateRazonSocial = (value) => {
  if (!value || typeof value !== 'string') return false;
  return value.trim().length >= 3;
};

export const getRazonSocialHints = (value) => {
  if (value && !validateRazonSocial(value)) {
    const hints = [{ 
      variant: 'error', 
      text: 'La razón social debe tener un mínimo de 3 caracteres' 
    }];
    return hints;
  }
  return [];
};

export const validateFechaRange = (fechaDesde, fechaHasta) => { 
  if (!fechaDesde || !fechaHasta) {
    return true; // No validar rango si alguna fecha no es válida
  }
  const dateDesde = parseFecha(fechaDesde);
  const dateHasta = parseFecha(fechaHasta);
  
  if (!dateDesde || !dateHasta) return false;
  
  return dateDesde <= dateHasta;
};

export const parseFecha = (value) => {
  // Parsea fechas en formato dd/mm/yyyy
  if (!value) return null;
  const parts = value.split('/');
  if (parts.length !== 3) return null;
  const [day, month, year] = parts;
  if (!isValidDate(parseInt(day), parseInt(month), parseInt(year))) {
    return null;
  }
  return new Date(year, month - 1, day);
};

export const isValidDate = (day, month, year) => {
  const date = new Date(year, month - 1, day);
  return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day;
};

export const validateFecha = (value) => {
  if (!value) return false;
  const date = parseFecha(value);
  return date !== null && !isNaN(date.getTime());
};

export const getFechaDesdeHints = (value, fechaHasta) => {
  // Primero validar formato
  if (value && !validateFecha(value)) {
    return [{ 
      variant: 'error', 
      text: 'La fecha no es válida' 
    }];
  }
  
  // Luego validar rango
  if (value && fechaHasta && validateFecha(value) && validateFecha(fechaHasta)) {
    if (!validateFechaRange(value, fechaHasta)) {
      return [{ 
        variant: 'error', 
        text: 'La fecha inicial no debe superar a la final' 
      }];
    }
  }
  
  return [];
};

export const getFechaHastaHints = (value) => {
  // Solo validar formato, no mostrar hints para rango
  if (value && !validateFecha(value)) {
    return [{ 
      variant: 'error', 
      text: 'La fecha no es válida' 
    }];
  }
  return [];
};

export const parseImporteValue = (value) => {
  if (!value || typeof value !== 'string') return 0;
  // Remover puntos de miles y convertir coma decimal a punto
  const cleanValue = value.replace(/\./g, '').replace(',', '.');
  return parseFloat(cleanValue) || 0;
};

export const validateImporteRange = (importeDesde, importeHasta) => {
  if (!importeDesde || !importeHasta) {
    return true;
  }
  
  const valorDesde = parseImporteValue(importeDesde);
  const valorHasta = parseImporteValue(importeHasta);
  
  return valorDesde <= valorHasta;
};

export const getImporteDesdeHints = (value, importeHasta) => {
  // Validar rango solo si ambos campos tienen valores
  if (value && importeHasta) {
    if (!validateImporteRange(value, importeHasta)) {
      return [{ 
        variant: 'error', 
        text: 'El importe inicial no debe superar al final' 
      }];
    }
  }
  
  return [];
};

export const getImporteHastaHints = () => {
  // No mostrar hints para el campo "hasta", solo status de error
  return [];
};

export const isAcceptButtonDisabled = (formData) => {
  const {
    razonSocial,
    importeDesde,
    importeHasta,
    fechaDesde,
    fechaHasta
  } = formData;

  // Verificar si hay errores de validación
  const hasRazonSocialError = razonSocial && !validateRazonSocial(razonSocial);
  const hasFechaDesdeError = fechaDesde && !validateFecha(fechaDesde);
  const hasFechaHastaError = fechaHasta && !validateFecha(fechaHasta);
  const hasFechaRangeError = fechaDesde && fechaHasta &&
    validateFecha(fechaDesde) && validateFecha(fechaHasta) &&
    !validateFechaRange(fechaDesde, fechaHasta);
  const hasImporteRangeError = importeDesde && importeHasta &&
    !validateImporteRange(importeDesde, importeHasta);

  // Si hay algún error de validación, deshabilitar el botón
  return (hasRazonSocialError || hasFechaDesdeError || hasFechaHastaError ||
    hasFechaRangeError || hasImporteRangeError)
};

export const hasAnyFilterFilled = (formData) => {
  const {
    tipoFacturaSelected,
    estadoFacturaSelected,
    razonSocial,
    importeDesde,
    importeHasta,
    fechaDesde,
    fechaHasta,
    sectorSelected,
  } = formData;

  return Boolean(
    tipoFacturaSelected ||
    estadoFacturaSelected ||
    razonSocial ||
    importeDesde ||
    importeHasta ||
    fechaDesde ||
    fechaHasta ||
    (Array.isArray(sectorSelected)
      ? sectorSelected.length > 0
      : sectorSelected)
  );
};